import { forwardRef } from 'react';

import MuiDialog from '@mui/material/Dialog';
import MuiDialogActions from '@mui/material/DialogActions';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';


export const Dialog = forwardRef((props, ref) => {
  return <MuiDialog ref={ref} {...props} />;
});

Dialog.displayName = 'Dialog';
export const DialogTitle = forwardRef((props, ref) => {
  return <MuiDialogTitle ref={ref} {...props} />;
});

DialogTitle.displayName = 'DialogTitle';
export const DialogContent = forwardRef((props, ref) => {
  return <MuiDialogContent ref={ref} {...props} />;
});

DialogContent.displayName = 'DialogContent';
export const DialogActions = forwardRef((props, ref) => {
  return <MuiDialogActions ref={ref} {...props} />;
});
DialogActions.displayName = 'DialogActions';
